"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMISSIONS_MAPPING = {
    prefix: 'permissions',
    getPermissions: {
        path: '/getPermissions',
    },
    getUserRoles: {
        path: '/getUserRoles'
    },
    addUserRole: {
        path: '/addUserRole',
    },
    deleteUserRole: {
        path: '/deleteUserRole',
        parameter: '/:roleId'
    },
    updateUserRole: {
        path: '/updateUserRole',
        parameter: '/:roleId'
    },
    addUserRolePermission: {
        path: '/addUserRolePermission',
        parameter: '/:roleId/:permission'
    },
    checkAbilityToDeleteRole: {
        path: '/checkAbilityToDeleteRole',
        parameter: '/:roleId'
    },
    deleteUserRolePermission: {
        path: '/deleteUserRolePermission',
        parameter: '/:roleId/:permission'
    },
    getUserCustomPermissions: {
        path: '/getUserCustomPermissions',
        parameter: '/:userId'
    }
};
